import { Component } from '@angular/core';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { TPVServices } from '../../../tpv/services';
import { TakeawayServices } from '../../../takeaway/services';
import { HttpClient } from '@angular/common/http';


/**
 * Generated class for the PopupTicketRefund page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-ticket-stripe-refund',
  templateUrl: 'popup-ticket-stripe-refund.html',
})
export class PopupTicketStripeRefund {
  ticket: any;
  total_refund: number = 0;

  constructor(
    public globals: Globals,
    public translate: TranslateService,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public takeawayServices: TakeawayServices,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    private toastCtrl: ToastController) {
    this.ticket = this.navParams.get('ticket');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  async refund() {
    if (this.total_refund <= parseFloat(this.ticket.amount) && this.total_refund > 0) {
      this.viewCtrl.dismiss({
        'total_refund': this.total_refund,
      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-entra-canitdad-correcta'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-ticket-stripe-refund/popup-ticket-stripe-refund.ts